<div class="container mt-4">
  <ngb-alert
    *ngIf="alert"
    [type]="alert.type"
    (closed)="closeAlert()"
    class="sticky-top"
    style="top: 10px"
  >
    {{ alert.message }}
  </ngb-alert>
  <app-register-stepper *ngIf="showProgressStepper" [progressData]="getProgressData()" [user]="user"></app-register-stepper>
</div>

<div class="container mt-3 m-auto text-center">
  <span class="membership-selection-title">{{ showVetGroupMessage ? membershipSelectionVet4PetTitle : membershipSelectionTitle }}</span>
  <div class="text-center mt-3 mb-2" *ngIf="showBasicAccountButton && (showContinueWithBasicOnTop || showVetGroupMessage)">
    <span *ngIf="!userAlreadyHasASubscription" class="membership-selection-title">{{ membershipSelectionSubTitle }}</span>
    <a
      [routerLink]="[]"
      queryParamsHandling="preserve"
      (click)="completeMembershipSelection()"
      class=" membership-selection-title"
      *ngIf="!userAlreadyHasASubscription"
    >
      <u>{{ membershipSelectionSubTitleButtonText }}</u>
    </a>
  </div>
</div>

<div *ngIf="!isIdentiSmartTagPlanAvailable" class="container container--pricing-table mt-4 mb-3">
  <app-pricing-table
    [userCurrentProductType]="userCurrentProductType"
    [hidePrices]="true"
    [disabled]="loading"
    [showShortDescription]="false"
    [showFeatures]="true"
    [pricingPlans]="pricingPlans"
    [showWideIdentiAlertCard]="true"
    [user]="user"
    [petName]="petName"
    [availableProductIds]="availableProductIds"
    [buttonLabel]="'Learn more'"
    (onSelect)="select($event)"
    (onNavigateToProductPage)="navigateToProductPage($event)"
    [hasBuyNow]="true"
    [hideIcons]="true"
  ></app-pricing-table>
</div>

<div *ngIf="isIdentiSmartTagPlanAvailable" class="container container--pricing-table mt-4 mb-3">
  <app-fixed-pricing-table
    [viewOnly]="true"
    [showShortDescription]="true"
    [buttonLabel]="'Learn more'"
    [pricingPlans]="pricingPlans"
    [hidePrices]="true"
    (onSelect)="select($event)"
    [showDescriptionList]="false"
    [hideIcons]="true"
    [hasBuyNow]="true"
    [showPeachBanner]="false"
    [user]="user"
    [availableProductIds]="availableProductIds"
  >
  </app-fixed-pricing-table>
</div>

<div class="container d-flex flex-column align-items-center mb-4" *ngIf="showBasicAccountButton && !(showContinueWithBasicOnTop || showVetGroupMessage)">
  <span *ngIf="!userAlreadyHasASubscription">
    No I don't want to give {{ petName }} pet protection from loss, theft and straying
  </span>
  <a
    [routerLink]="[]"
    queryParamsHandling="preserve"
    (click)="completeMembershipSelection()"
    class="complete-link"
    *ngIf="!userAlreadyHasASubscription"
  >
    Keep basic account
  </a>

  <span *ngIf="userAlreadyHasASubscription">Or continue with your current</span>
  <a
    [routerLink]="[]"
    queryParamsHandling="preserve"
    (click)="continueWithCurrentMembership()"
    class="complete-link"
    *ngIf="userAlreadyHasASubscription"
  >
    {{ currentMembershipName }} membership
  </a>
</div>
